import React from "react";
import { ScheduleEditForm } from "../../scheduleRulesAccordion/scheduleEditForm";

import "../RulePopup.scss";

export const RulePopupEditForm = ({
  formProps,
  handleDaysChange,
  handleTimeChange,
}) => {
  const { timeStart, timeEnd, selectedDays } = formProps.values;

  return (
    <ScheduleEditForm
      schedule={{ timeStart, timeEnd, selectedDays }}
      onDaysChange={handleDaysChange}
      onTimePickerChange={handleTimeChange}
    />
  );
};
